export default __webpack_public_path__ + "static/media/15th Finance Commission Water Sanitation Fund Advisory English 17 March 2020.8f27f94b.pdf";